// Chamada da fatura agrupada (#5786). Fica fora de emissaoBoletoAgrupado.ts porque aquele arquivo
// é lógica pura testada sob `node --test`; este aqui fala com a rede e com o Vite.

import { supabase } from './supabase';

/**
 * Monta a fatura agrupada (#5786) e devolve os bytes. Vai por fetch, e não por
 * `supabase.functions.invoke`, pelo mesmo motivo do PDF do boleto: o invoke lê a resposta pelo
 * Content-Type e corromperia um 'application/pdf' (ver src/lib/gatewayResolver.ts).
 *
 * O documento é sempre desenhado na hora, a partir do fechamento — não fica salvo em lugar nenhum.
 */
export async function gerarPdfFaturaAgrupada(
  fechamentoId: number,
  vencimento: string,
): Promise<Blob> {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) throw new Error('Sessão expirada. Entre novamente.');
  const res = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/gerar-pdf-fatura-agrupada`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      apikey: import.meta.env.VITE_SUPABASE_ANON_KEY,
      Authorization: `Bearer ${session.access_token}`,
    },
    body: JSON.stringify({ fechamento_id: fechamentoId, vencimento }),
  });
  if (!res.ok) {
    const msg = await res.json().catch(() => null);
    // 546 = o servidor ficou sem recursos. Acontece ao gerar vários documentos em sequência, com o
    // anterior ainda em memória; repetir resolve. Sem esta frase, o operador só vê um código.
    if (res.status === 546 || msg?.code === 'WORKER_RESOURCE_LIMIT') {
      throw new Error('O servidor ficou sem recursos para montar o documento. Espere alguns segundos e gere de novo.');
    }
    throw new Error(msg?.error || `Falha ao gerar a fatura agrupada (status ${res.status}).`);
  }
  return res.blob();
}

